(function () {
    angular
        .module('journey.canvas.srv', [])
        .factory('canvasService', ['$rootScope', '$http', '$templateCache', 'API_OPTS', 'EDITOR_URL', '$stateParams', 'cacheService','helpers', 'EDITOR_NEW_URL',  canvasService])
        .factory('plumbService', ['canvasService', 'helpers', '$rootScope', plumbService])
        .factory('uiService', ['$http', 'API_OPTS', uiService])
        .factory('cacheService', ['$rootScope', cacheSetter])
        .factory('signalSrv', ['HUB', signalRHub])
        .constant('HUB', {
            URL : calcAProHubUrl(),
            NAME: 'download',
            EVENT: 'downloadPdf'
        })
        .constant('CANVAS_OPTS', {canvasOptions: {top: 12020, left: 12020, updatePos: 12400}})
        .constant('API_OPTS', {
            API_BASE_UI_URL: 'http://api.benchmarkemail.com/1.0/',
            API_FEEDBACK: 'https://script.google.com/a/benchmarkemail.com/macros/s/AKfycbzV0is9krj7yu9cngz3vaLvbVwrcLlcGg3wUCaY4gQNDcntsaUG/exec',
            API_BENCHMARK_REST: 'https://restapi.benchmarkemail.com/',
            API_INTEGRATIONS: calcIntegrationsApiUrl(),
            API_BASE_URL: calcAProApiUrl(),
            API_VERSION: 'api/v1/',
            API_VERSION_2: 'api/v2/',
            API_VERSION_3: 'api/v3/',
            API_VERSION_4: 'api/v4/',
            API_CONTACT_LIST: 'lists/',
            API_CONTACT_LIST_CREATE: 'lists/create',
            API_SEGMENT_LIST: 'segment/',
            API_ACTIVE_EMAILS: 'activated/',
            API_SUMMARY: 'reports/reports/summary/',
            API_EMAILS: 'emails/',
            API_EMAILS_USERS: 'emails/user/',
            API_DUPLICATE_EMAILS: 'validateemailname/',
            API_DUPLICATE_EMAIL_VALID: 'emails/duplicatevalidname/',
            API_SEGMENTS: 'segments/',
            API_TEMPLATE: 'journeytemplate/',
            API_EDITOR_GET_PERMANENT_TOKEN: 'editor/permanenttoken/',
            API_DUPLICATE_EMAIL: 'emails/duplicate/',
            API_DUPLICATE_ACTIVATE_EMAIL: 'activated/emails/duplicate/',
            API_GET_TOKEN: 'token/gettoken',
            API_ACTIVATE_JOURNEY: 'activate/',
            API_BLOCK_JOURNEY: 'block/',
            API_SUMMARY_EMAIL: 'reports/reports/summary/',
            API_SAVE_STATS: 'reports/export/summary/',
            API_ALL_SUMMARY_EMAIL: 'reports/emails/summary/',
            API_CSETTING: 'client/settings',
            API_SEARCH_LIST: 'list',
            API_SEARCH_SEGMENT: 'segment',
            API_SEARCH_EMAIL: 'emails/search',
            API_TRACKER_TESTED: 'tracker/tested',
            API_CLIENT_SETTINGS: 'Client/Setting',
            API_CLIENT_NOTIFICATIONS: 'Client/Notification?status=1',
            API_UPDATE_ACTIVATED: 'activated/update/',
            API_NODE_DETAILS: 'journey/:journeyId/node/element/:elementId',
            API_NODE_METRIC_DETAILS_GROUP: 'journey/:journeyId/node/:nodeId/metric/summary?nodeType={nodeType}',
            API_METRIC_DETAILS_SUMMARY_BY_TYPE: 'journey/:journeyId/node/:nodeId/metric?metricType={metricType}&page={page}&size={size}&filter={filter}',
        })
        .constant('EDITOR_URL', 'https://jb-edit.benchmarkemail.com/editor/')
        .constant('EDITOR_NEW_URL', 'https://ui.benchmarkemail.com/AP/')
        .run(['$q', '$rootScope', 'canvasService', '$location', preBuildServices]);

    function canvasService($rootScope, $http, $templateCache, API_OPTS, EDITOR_URL, $stateParams, cacheService, helpers, EDITOR_NEW_URL) {
        //Returns the list of templates
        var getTemplateList = function () {
            return [
                "actions/add-to-list",
                "actions/facebook-audience",
                "actions/add-wait-time",
                "actions/remove-from-list",
                "actions/remove-from-segment",
                "actions/update-field",
                "actions/send-email",
                "actions/send-email-modal",
                "actions/looping",
                "entry/added-to-list",
                "entry/added-to-segment",
                "entry/date-and-time",
                "entry/website-engagement",
                "conditions/is-on-list-or-segment",
                "conditions/is-in-segment",
                "conditions/is-not-in-segment",
                "conditions/website-activity",
                "conditions/email-engagement",
                "conditions/options/if-else",
                "elements-menu-if-else",
                "active_templates/entries/active-website-engagement",
                "active_templates/entries/active-added-to-list",
                "active_templates/entries/active-added-to-segment",
                "active_templates/entries/active-date-and-time",
                "active_templates/actions/active-add-wait-time",
                "active_templates/actions/active-add-to-list",
                "active_templates/actions/active-send-email",
                "active_templates/actions/active-send-email-modal",
                "active_templates/actions/active-remove-from-list",
                "active_templates/actions/active-facebook-audience",
                "active_templates/actions/active-update-field",
                "active_templates/actions/active-looping",
                "active_templates/actions/modal-active-facebook-audience",
                "active_templates/actions/modal-active-add-wait-time",
                "active_templates/conditions/active-is-on-list-or-segment",
                "active_templates/conditions/active-in-segment-condition",
                "active_templates/conditions/active-not-in-segment",
                "active_templates/conditions/active-website-activity",
                "active_templates/conditions/active-email-engagement",
                "active_templates/conditions/active-rectangle-connector",
                "active_templates/conditions/active-if-else",
                "active_templates/entries/modal-active-added-to-list",
                "active_templates/entries/modal-active-added-to-segment",
                "active_templates/entries/modal-active-website-engagement",
                "active_templates/entries/modal-active-date-and-time"
            ];
        };

        //Preloads templates to the dom
        var preloadTemplate = function (tplName) {
            $http.get('app/views/templates/' + tplName + '.tpl.html').success(function (data) {
                $templateCache.put(tplName, data);
            });
        };

        //Preloads templates to the dom
        var preloadDefaultJourneys = function (tplName) {
            return $http.get('app/services/mocks/defaultTemplate' + tplName + '.json');
        };

        //Returns journey promise
        var getJourney = function (journeyId) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + journeyId, {
                headers: {Authorization: 'OAuth ' + $rootScope.jbToken}
            });
        };

        //Returns promise of paginate journeys
        var getPaginateJourneys = function (limit, offset) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'getalljourneys/' + limit, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Offset': offset
                }
            });
        };

        //Returns promise of paginate templates
        var getPaginateTemplates = function (limit, offset) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeytemplate/alltemplates/' + limit, {
                 headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken,
                    'Offset': offset
                }
            });
        };

        // returns value true or false if the email isUniqueName
        const validateDuplicateEmailName = (emailName) => {
            const data = {EmailName: emailName};

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAILS, data, {
                headers: {
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        //Returns value true or false if the email isUniqueName
        let duplicateEmailValidName = function (emailId, emailName, status = 1, journeyId) {
            let data = {EmailName: emailName},
                url = (status === 3 || status === 4) ? API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_DUPLICATE_EMAIL_VALID
                                                     : API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAIL_VALID;
            if(status === 3 || status === 4) {
                data.JourneyId = journeyId;
            }

            return $http.post(url + emailId, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        //Create Journey
        var createJourney = function(name, payload) {
            cacheService.deleteCachable();

            var data = {
                JourneyTitle: name,
                JourneyConfiguration: payload
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys', data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        //Create Journey
        let journeyName = (name) => {
            cacheService.deleteCachable();

            const data = {
                JourneyTitle: name
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeyname', data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        //Update Journey
        let updateJourney = (payload, jbId, jbSize = 0) => {
            cacheService.deleteCachable();
            let url = (jbSize < 40) ? API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId : API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId,
                settings = {
                url: url,
                method: 'PUT',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                data: JSON.stringify(payload)
            };

            return $.ajax(settings);
        };
        //End update Journey

        var deleteTemplate = function (templatesId) {
            var cId = $rootScope.jbClient;

            var payload = {
                "ClientId": cId,
                "TemplateIds": templatesId
            };

            return $.ajax({
                url: API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeytemplatemultiple/',
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                data: JSON.stringify(payload)
            });
        };

        //Create Journey Template
        var createJourneyTemplate = function(title, name, description, payload) {
            var data = {
                JourneyTitle: title,
                JourneyName: name,
                JourneyDescription: description,
                JourneyConfiguration: payload
            };

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_TEMPLATE, data, {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                }
            });

        };
        //End create Journey Template

        //Saves the current journey to local storage
        var saveJourneyStorage = function (id, data, updateToDb) {
            if(updateToDb) {
                const updatedPosData = helpers.updateAllPos(JSON.parse(data));
                _saveProgress(JSON.stringify(updatedPosData), $stateParams.canvasId);
            }
            if (typeof(Storage) !== "undefined") {
                //var for checking connection when change on canvas controller
                if (data) {
                    $rootScope.conn = JSON.parse(data);
                }
                //
                return $rootScope.localStorageSupported? localStorage.setItem(id, data) : [];
            } else {
                return {'noStorage': true};
            }
        };

        var _saveProgress = function(data, id) {
            var jbTitle = $rootScope.currentJBTitle || 'Journey Name',
                payload = {
                    JourneyTitle: jbTitle,
                    JourneyConfiguration: data
                };

            updateJourney(payload, id)
                .success(function(res){/*data saved, no action needed*/});
        };

        //Get journey from local storage
        var getJourneyStorage = function (id) {
            if (typeof(Storage) !== "undefined") {
                return JSON.parse(localStorage.getItem(id));
            } else {
                return {'noStorage': true};
            }
        };

        //Remove journey storage
        var removeJourneyStorage = function (id) {
            if (typeof(Storage) !== "undefined") {
                return JSON.parse(localStorage.removeItem(id));
            } else {
                return {'noStorage': true};
            }
        };

        var journeyStorageExists = function (id) {
            if (this.getJourneyStorage(id)) {
                return true;
            } else {
                return false;
            }
        };

        var getInitIfElseModel = function (val) {
            var conditionModel = {
                'inList': {
                    'class': 'select-list',
                    'label': 'Select a List',
                    'selectedAction': 'inList',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'notInList': {
                    'class': 'select-list',
                    'label': 'Select a List Not',
                    'selectedAction': 'notInList',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'inSegment': {
                    'class': 'select-list',
                    'label': 'Select a List',
                    'selectedAction': 'inSegment',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'notInSegment': {
                    'class': 'select-list',
                    'label': 'Select a List Not',
                    'selectedAction': 'notInSegment',
                    'selectedOpt': [],
                    'type': 'list',
                    'condition': 'and',
                    'hasError': false
                },
                'hasOpenedEmail': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasOpenedEmail',
                    'selectedOpt': [],
                    'type': 'email',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotOpenedEmail': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotOpenedEmail',
                    'selectedOpt': [],
                    'type': 'email',
                    'condition': 'and',
                    'hasError': false
                },
                'hasClickedALink': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasClickedALink',
                    'selectedOpt': [],
                    'type': 'link',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotClickedALink': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotClickedALink',
                    'selectedOpt': [],
                    'type': 'link',
                    'condition': 'and',
                    'hasError': false
                },
                'hasVisitedAnyWebsite': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasVisitedAnyWebsite',
                    'selectedOpt': [],
                    'type': 'visited',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotVisitedAnyWebsite': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotVisitedAnyWebsite',
                    'selectedOpt': [],
                    'type': 'visited',
                    'condition': 'and',
                    'hasError': false
                },
                'hasVisitedUrl': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasVisitedUrl',
                    'selectedOpt': [],
                    'type': 'url',
                    'condition': 'and',
                    'hasError': false
                },
                'hasNotVisitedUrl': {
                    'class': 'select-list',
                    'label': 'Select an option',
                    'selectedAction': 'hasNotVisitedUrl',
                    'selectedOpt': [],
                    'type': 'url',
                    'condition': 'and',
                    'hasError': false
                }
            };

            return conditionModel[val];

        };

        var getActionIfElseList = function (type) {
            var list = {
                'action': {
                    inSegment: $rootScope.translate('canvas.journey.isInSegment'),
                    notInSegment: $rootScope.translate('canvas.journey.isNotInSegment'),
                    inList: $rootScope.translate('canvas.condition.ifElse.inList'),
                    notInList: $rootScope.translate('canvas.condition.ifElse.notInList'),
                    hasOpenedEmail: $rootScope.translate('canvas.condition.ifElse.hasOpenEmail'),
                    hasNotOpenedEmail: $rootScope.translate('canvas.condition.ifElse.hasNotOpenEmail'),
                    hasClickedALink: $rootScope.translate('canvas.condition.ifElse.hasClickedLink'),
                    hasNotClickedALink: $rootScope.translate('canvas.condition.ifElse.hasNotClickedLink'),
                    hasVisitedUrl: $rootScope.translate('canvas.condition.ifElse.hasVisitedUrl'),
                    hasNotVisitedUrl: $rootScope.translate('canvas.condition.ifElse.hasNotVisitedUrl')
                },
                'contact-details': {},
                'date-and-time': {}

            };

            return list[type];
        };

        var getContactList = function (offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST + offset + '/' + limit, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        let searchContactList = (search) => {
            let data = JSON.stringify({PageNumber: 0, PageSize: 50, Name:search});
            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}${API_OPTS.API_SEARCH_LIST}`, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        let searchContactSegment = (search) => {
            let data = JSON.stringify({PageNumber: 0, PageSize: 50, Name:search});
            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}${API_OPTS.API_SEARCH_SEGMENT}`, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        let searchEmails = (search) => {
            let data = JSON.stringify({PageNumber: 0, PageSize: 50, Name:search});
            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}${API_OPTS.API_SEARCH_EMAIL}`, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var createContactList = function (listName) {
            var data = JSON.stringify({"ListName" :listName});
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST_CREATE, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getSegments = function (offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEGMENT_LIST + offset + '/' + limit, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getSegmentsById = function (segments) {
            var data = JSON.stringify({"Segments" :segments});
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_SEGMENTS, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getLists = function (lists) {
            var data = JSON.stringify({"Lists" :lists});
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_CONTACT_LIST, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getEmailList = function (offset, limit) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS + offset + '/' + limit, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getEmailDetails = function (eid) {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_EMAILS + eid, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var getUserEmailAddress = function () {
            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS_USERS, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var createEmail = function (data) {
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var updateEmailData = function (eid, data) {
            var settings = {
                'url': API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EMAILS + eid,
                'method': 'PUT',
                'headers': {
                    'content-type': 'application/json',
                    'Authorization': 'OAuth ' + $rootScope.jbToken
                },
                'data': JSON.stringify(data)
            };
            return $.ajax(settings);
        };

        const duplicateEmail = (eId, eName, mergeTags) => {
            let prom;

            if (mergeTags.length) {
                prom = $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_DUPLICATE_EMAIL + eId, {EmailName: eName, ListId:mergeTags[0].id}, {
                        headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
                    });
            }
            else {
                prom = $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_DUPLICATE_EMAIL + eId, {EmailName: eName}, {
                        headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
                    });
            }

            return prom;
        };



        var redirectToEditor = function(editor, emailId, jbId) {
            var redirectUrl = AP.Flags.newEditor ? EDITOR_NEW_URL : EDITOR_URL;
            switch(editor) {
                case '400':
                    // dad
                    redirectUrl += AP.Flags.newEditor ? 'EmailEditor' : 'c.html';
                    break;
                case '402':
                    // html
                    redirectUrl += AP.Flags.newEditor ? 'EmailCustom' : 'b.html';
                    break;
                case '401':
                    // text
                    redirectUrl += AP.Flags.newEditor ? 'EmailText' : 'a.html';
                    break;
                default:
                    redirectUrl += AP.Flags.newEditor ? 'EmailText' : 'a.html';
            }

            redirectUrl += !AP.Flags.newEditor ? '?eid=' + emailId : '?e=' + emailId;
            redirectUrl += !AP.Flags.newEditor ? '&token=' + $rootScope.jbToken : '';
            redirectUrl += '&redirect=' + encodeURIComponent(window.location.origin + '/#/canvas/' + jbId + '/' + emailId);
            window.location = redirectUrl;
            return;
        };

        var getVersionByType = function(type) {
            var resType;
            switch(type) {
                case 'dad':
                    resType = '400';
                    break;
                case 'html':
                    resType = '402';
                    break;
                case 'text':
                    resType = '401';
                    break;
                default:
                    resType = '401';
            }
            return resType;
        };

        var getTrackerToken = function () {
            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_GET_TOKEN,
                {UserToken :  $rootScope.jbToken},
                {headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        var activateJourney = function(jbId) {
            cacheService.deleteCachable();

            return $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_ACTIVATE_JOURNEY + jbId, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        //Unknow = 0,Draft = 1,New = 2,Active = 3,Deactivated = 4,Paused = 5,Deleted = 6
        var setJourneyStatus = function(jbId, status) {
            cacheService.deleteCachable();

            return $http.post(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'journeys/' + jbId + '/' + status, {}, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        // block status 1: block, 0: unblock
        let blockJourney = (jbId, status) => {
            cacheService.deleteCachable();
            return $http.get(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION_2}journeys/${API_OPTS.API_BLOCK_JOURNEY}${jbId}/${status}`, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        let saveStatsAsLists = (payload) => {
            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION_2}${API_OPTS.API_SAVE_STATS}`, payload, {
                headers: {
                    'Authorization': `OAuth ${$rootScope.jbToken}`,
                    'Content-Type': 'application/json'
                }
            });
        };

        const getCoach = (id) =>  $http.get(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}coach/${id}`, {
                                      headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
                                  });

        const saveCoach = (id, data, status) => {
            let payload = {
                JourneyVersion: 1,
                Parameters: JSON.stringify(data),
                JourneyId: id,
                EnableCoach: status
            };

            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}coach`, payload, {
                        headers: {
                            'Authorization': `OAuth ${$rootScope.jbToken}`,
                            'Content-Type': 'application/json'
                        }
                   });
        };

        const sendFeedback = (payload) => $http({
            url: API_OPTS.API_FEEDBACK,
            dataType: 'json',
            method: "GET",
            params: payload
        });

        const getResponsiveInfo = () => $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/Responsive', {
                  headers: {'AuthToken': $rootScope.jbToken}
              });

        const getSmartSendingInfo = () => $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/SSEnabled', {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const getClientInfo = () => $http.get(API_OPTS.API_BENCHMARK_REST + 'Client', {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const getPlanInfo = () => $http.get(API_OPTS.API_BENCHMARK_REST + 'Client/Plan', {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const getDownloadInfo = (emailId, reportType) => $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' +  reportType + '/Report/Download', {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const downloadFile = (emailId, reportType, payload) => $http.post(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' +  reportType + '/Report/Download', payload, {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const emailPin = (emailId) => $http.post(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/' +  reportType + '/Report/Download', payload, {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const getReportByType = (emailId, type, sort = 'desc', pageNum = 1, pageSize = 10) => $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/Report/' + type + '?Filter=&PageNumber=' + pageNum + '&PageSize=' + pageSize + '&Status=&OrderBy=date&SortOrder=' + sort, {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const getPreview = (emailId) => $http.get(API_OPTS.API_BENCHMARK_REST + 'Emails/' + emailId + '/Preview', {
            headers: {'AuthToken': $rootScope.jbToken}
        });

        const searchAutomations = (search, status, offset = 0) => {
            let data = JSON.stringify({JourneyTitle:search, Status:status});
            return $http.post(`${API_OPTS.API_BASE_URL}${API_OPTS.API_VERSION}journeys/filter/50`, data, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken, Offset: offset}
            });
        };

        const getActiveEmails = (elementId, journeyId) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_ACTIVE_EMAILS }${ API_OPTS.API_EMAILS }${ elementId }`,
                payload = { JourneyId: journeyId, JourneyVersion: 1 };

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Create draft email endpoint
        const createDraftEmail = (payload) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_ACTIVE_EMAILS }${ API_OPTS.API_EMAILS }`;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Create duplicate activated email endpoint
        const createDuplicateActivated = (payload, emailId) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_DUPLICATE_ACTIVATE_EMAIL }${ emailId }`;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Active draft email endpoint
        const activeDraftEmail = (payload, vertsion) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_ACTIVE_EMAILS }${ API_OPTS.API_EMAILS }${ API_OPTS.API_ACTIVATE_JOURNEY }${ vertsion }`;

            return $http.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        const testTracker = (testUrl) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_TRACKER_TESTED}`;

            return $http.post(url, JSON.stringify({
                    SiteUrl: testUrl
                }), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth 4B6AA6FB-73AC-44CF-B4E3-BC96BD1A3024'
                }
            });
        };

        // Delete draft email endpoint
        const deleteDraftEmail = (payload, vertsion) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_ACTIVE_EMAILS }${ API_OPTS.API_EMAILS }${ vertsion }`;

            return $http.delete(url, {
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };
        // Get url links
        const emailUrls = (elId) => $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/urls/' + elId, {
            headers: {'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken}
        });

        // get all connections
        const getConnections = () => $http.get(API_OPTS.API_INTEGRATIONS + 'connect/test/FacebookAudiance', {
            headers: {'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken}
        });

        // get audiences
        const getAudiences = () => $http.get(API_OPTS.API_INTEGRATIONS + 'configuration/Facebook/Audiance/', {
            headers: {'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken}
        });

        // connect fb
        const fbConnect = (redirectUrl) => $http.get(API_OPTS.API_INTEGRATIONS + 'connect/facebookaudiance', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'OAuth ' + $rootScope.jbToken,
                'Redirect': redirectUrl
            }
        });

        // disconnect fb
        const fbDisconnect = (redirectUrl) => $http.get(API_OPTS.API_INTEGRATIONS + 'disconnect/FacebookAudiance/', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'OAuth ' + $rootScope.jbToken,
                'Redirect': redirectUrl
            }
        });

        // Get client settings
        const getClientSettings = () => $http.get(API_OPTS.API_BENCHMARK_REST + API_OPTS.API_CLIENT_SETTINGS, {
            headers: { 'Content-Type': 'application/json', 'AuthToken': $rootScope.jbToken }
        });

        // Get client settings
        const getNotificationBadge = () => $http.get(API_OPTS.API_BENCHMARK_REST + API_OPTS.API_CLIENT_NOTIFICATIONS, {
            headers: { 'Content-Type': 'application/json', 'AuthToken': $rootScope.jbToken }
        });

        const updateActivatedNodes = (payload) => {
            const url = `${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }${ API_OPTS.API_UPDATE_ACTIVATED}${payload.JourneyId}`;

            return $http.post(url, JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        // Gets all summary report data
        const getAllSummaryReports = (id) => $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION_2 + API_OPTS.API_ALL_SUMMARY_EMAIL + id, {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
        });

        /****
         **** Trash emails section
         ****/
        const getTrashEmails = () => $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/trash', {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
        });

        const trashEmail = (id) => $http.put(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/trash/' + id, {} ,{
            headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
        });

        const restoreTrashEmail = (id) => $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'emails/restore/trash/' + id, {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
        });

        // get update fields
        const getFields = (listId) => $http.get(API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + 'fields/' + listId, {
            headers: { 'Content-Type': 'application/json', 'Authorization': 'OAuth ' + $rootScope.jbToken }
        });

        const getTrackerSummary = (startDate, endDate) => {
            const payload = {
                FromDate: startDate,
                ToDate: endDate
            };

            return $http.post(`${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }reports/tracker/summary`, JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        const getTrackerSummaryDetails = (startDate, endDate, url) => {
            const payload = {
                FromDate: startDate,
                ToDate: endDate,
                URL: url
            };

            return $http.post(`${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }reports/tracker/detail`, JSON.stringify(payload), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : 'OAuth ' + $rootScope.jbToken
                }
            });
        };

        const getNotifications = (status) => {
           return $http.get(API_OPTS.API_BENCHMARK_REST + `Client/Notification?status=${status}`, {
                headers: {'AuthToken': $rootScope.jbToken}
           });
        };

        const setNotificationAsRead = () => {
            return $http.patch(API_OPTS.API_BENCHMARK_REST + `Client/Notification`, { 'isNew': '0' }, {
                headers: {'AuthToken': $rootScope.jbToken}
            });
        };

        const updateNotificationRead = (id) => {
            return $http.patch(API_OPTS.API_BENCHMARK_REST + `Client/Notification/${id}`, {}, {
                headers: {'AuthToken': $rootScope.jbToken}
            });
        };

        const generateThumbs = (id) => {
            return $http.post(API_OPTS.API_BENCHMARK_REST + `/Emails/${id}/ScreenCapture`, {}, {
                headers: {'AuthToken': $rootScope.jbToken}
            });
        };

        const getSubjectLine = () => {
            return $http.get(`${ API_OPTS.API_BASE_URL }${ API_OPTS.API_VERSION }subjectline`, {
                headers: { 'Authorization' : 'OAuth ' + $rootScope.jbToken }
            });
        };

        const getEmptyEmail = () => {
            return $http.get(`${ API_OPTS.API_BENCHMARK_REST }Emails/0`, {
                headers: { 'AuthToken': $rootScope.jbToken }
            });
        };

        const getNodeMetricDetailsGroupByType = (journeyId, nodeId, nodeType) => {
            const methodUrl = API_OPTS.API_NODE_METRIC_DETAILS_GROUP
                .replace(':journeyId', journeyId)
                .replace(':nodeId', nodeId)
                .replace('{nodeType}', nodeType);

            const uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        const getNodeMetricDetailsSummaryByType = (journeyId, nodeId, metricType, page = 0, size = 10, filter = '') => {
            const methodUrl = API_OPTS.API_METRIC_DETAILS_SUMMARY_BY_TYPE
                .replace(':journeyId', journeyId)
                .replace(':nodeId', nodeId)
                .replace('{metricType}', metricType)
                .replace('{page}', page)
                .replace('{size}', size)
                .replace('{filter}', filter);

            const uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        const getNodeDetails = (journeyId, elementId) => {
            const methodUrl = API_OPTS.API_NODE_DETAILS
                .replace(':journeyId', journeyId)
                .replace(':elementId', elementId);

            const uri = API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + methodUrl;

            return $http.get(uri, {
                headers: {'Authorization': 'OAuth ' + $rootScope.jbToken}
            });
        };

        return {
            //Gets a list of all available templates
            getTemplateList: getTemplateList,
            //PreLoads templates from canvas
            preloadTemplate: preloadTemplate,
            //Grabs a Journey by ID
            getJourney: getJourney,
            //Save Journey
            updateJourney: updateJourney,
            //Creates a new Journey
            createJourney: createJourney,
            //Save Data to journey storage
            saveJourneyStorge: saveJourneyStorage,
            //Save Data to journey storage
            getJourneyStorage: getJourneyStorage,
            //Remove journey storage
            removeJourneyStorage: removeJourneyStorage,
            //Check if journey storage exists
            journeyStorageExists: journeyStorageExists,
            //Gets the list of conditions for the if else
            getInitIfElseModel: getInitIfElseModel,
            //Get Action lists by type
            getActionIfElseList: getActionIfElseList,
            //Get Contact List
            getContactList: getContactList,
            // create contact list
            createContactList: createContactList,
            //Get Segments
            getSegments: getSegments,
            //Gets a list of segments by Array
            getSegmentsById: getSegmentsById,
            //Gets a list by Array
            getLists: getLists,
            //Get Email List
            getEmailList: getEmailList,
            // update email details
            getEmailDetails: getEmailDetails,
            // gets list of email addresses for a user
            getUserEmailAddress: getUserEmailAddress,
            //Create email
            createEmail: createEmail,
            // update an email
            updateEmailData: updateEmailData,
            // duplicates an existing email
            duplicateEmail: duplicateEmail,
            // validates email name true or false
            validateDuplicateEmailName: validateDuplicateEmailName,
            // redirects to an editor URL
            redirectToEditor: redirectToEditor,
            // delete Templates
            deleteTemplate: deleteTemplate,
            //Get list of journeys with paginate parameters
            getPaginateJourneys: getPaginateJourneys,
            // gets the type of editor by type
            getVersionByType: getVersionByType,
            //Generates an encrypted token
            getTrackerToken: getTrackerToken,
            //Create Journey Template
            createJourneyTemplate : createJourneyTemplate,
            //Get paginated Journey Templates
            getPaginateTemplates: getPaginateTemplates,
            //Deactivate, Delete
            setJourneyStatus: setJourneyStatus,
            //Activate a Journey
            activateJourney: activateJourney,
            //Load Default Templates
            preloadDefaultJourneys: preloadDefaultJourneys,
            // duplicates email with a valid name
            duplicateEmailValidName: duplicateEmailValidName,
            // gets a coach object
            getCoach: getCoach,
            // saves a coach object
            saveCoach: saveCoach,
            // validate journey name
            journeyName: journeyName,
            // blocks/unblocks a journey
            blockJourney: blockJourney,
            // searches in a list
            searchContactList: searchContactList,
            // searches in a list
            searchContactSegment: searchContactSegment,
            // searches emails
            searchEmails: searchEmails,
            // saves stats as lists
            saveStatsAsLists: saveStatsAsLists,
            // sends feedback to the spreassheet
            sendFeedback: sendFeedback,
            // get client info
            getResponsiveInfo: getResponsiveInfo,
            // get client info
            getClientInfo: getClientInfo,
            // gets plan info
            getPlanInfo: getPlanInfo,
            // gets download info
            getDownloadInfo: getDownloadInfo,
            // downloads a report file by type
            downloadFile: downloadFile,
            // sends the pin through email
            emailPin: emailPin,
            // get opens reports
            getReportByType: getReportByType,
            // get preview
            getPreview: getPreview,
            // search Automations
            searchAutomations: searchAutomations,
            // Get active emails of a element_id
            getActiveEmails: getActiveEmails,
            // Create draft email after save new email
            createDraftEmail: createDraftEmail,
            // Active Draft Email
            activeDraftEmail: activeDraftEmail,
            // Delete draft email
            deleteDraftEmail: deleteDraftEmail,
            // creates an activate duplicate
            createDuplicateActivated: createDuplicateActivated,
            // tests is a tracker is installed in a site
            testTracker: testTracker,
            // get links of an email
            emailUrls: emailUrls,
            // Get client settings
            getClientSettings: getClientSettings,
            // get all connections
            getConnections: getConnections,
            // fb connect
            fbConnect: fbConnect,
            // get audiences
            getAudiences: getAudiences,
            // disconnect fb
            fbDisconnect: fbDisconnect,
            // get notifications
            getNotificationBadge: getNotificationBadge,
            // update activated nodes
            updateActivatedNodes: updateActivatedNodes,
            // get all summaries
            getAllSummaryReports: getAllSummaryReports,
            // get trash emails
            getTrashEmails: getTrashEmails,
            // set trash email
            trashEmail: trashEmail,
            // restore trash email
            restoreTrashEmail: restoreTrashEmail,
            // update fields
            getFields: getFields,
            // get tracking data
            getTrackerSummary: getTrackerSummary,
            // get tracker summary details
            getTrackerSummaryDetails: getTrackerSummaryDetails,
            // get notifications
            getNotifications: getNotifications,
            // mark as read
            updateNotificationRead: updateNotificationRead,
            // generates thumbs
            generateThumbs: generateThumbs,
            // get subject line
            getSubjectLine: getSubjectLine,
            // get empty email data
            getEmptyEmail: getEmptyEmail,
            // sets notification as read
            setNotificationAsRead: setNotificationAsRead,
            // get smart send info
            getSmartSendingInfo: getSmartSendingInfo,
            // get node metric details group by metric type
            getNodeMetricDetailsGroupByType,
            // get node metric details summary by metric type
            getNodeMetricDetailsSummaryByType,
            // get node  details by Journey Id and Element Id
            getNodeDetails
        }
    }

    function cacheSetter($rootScope) {
        var _setCache = function(id, data) {
            var res = false;

            if (typeof(Storage) !== "undefined" && $rootScope.localStorageSupported) {
                res = sessionStorage.setItem(id, data);
            }
            return res;
        };

        var _destroyCache = function(id) {
            var res = false;

            if (typeof(Storage) !== "undefined") {
                res = sessionStorage.removeItem(id);
            }

            return res;
        };

        var _getCache = function(id, isJSON) {
            var res = false;

            if (typeof(Storage) !== "undefined") {
                res = sessionStorage.getItem(id);
            }

            return res;
        };

        var _deleteCacheByPattern = function(pattern) {
            var l = sessionStorage.length,
                removeArr = [];

            for (var i = 0; i < l; i++) {
                var key = sessionStorage.key(i);
                if (key.indexOf(pattern) > -1) {
                    removeArr.push(key);
                }
            }

            for (var j = 0; j < removeArr.length; j++) {
                sessionStorage.removeItem(removeArr[j]);
            }
        };

        var _deleteCachable = function() {
            localStorage.removeItem('cache:journeys:list');
        };

        return {
            setCache: _setCache,
            destroyCache: _destroyCache,
            getCache: _getCache,
            deleteCachePattern: _deleteCacheByPattern,
            deleteCachable: _deleteCachable
        }

    }

    function signalRHub(HUB) {

        function _initFunc() {
            return HUB;
        }

        return {
            init: _initFunc,
        }
    }

    function uiService($http, API_OPTS) {
        $http.defaults.useXDomain = true;
        //Sets the user context

        var _getPermanentToken = function (userName, password) {

            var payload = {
                "Password": password,
                "UserName": userName
            };

            return $http({
                method: 'POST',
                    url: API_OPTS.API_BASE_URL + API_OPTS.API_VERSION + API_OPTS.API_EDITOR_GET_PERMANENT_TOKEN,
                    data: JSON.stringify(payload)
            });
        };

        return {
            permanentTokenGet: _getPermanentToken
        }
    }

    function plumbService(canvasService, helpers, $rootScope) {

        var initPlumb = function () {
            //Bind ready event to use later
            jsPlumb.bind('ready', function () {
                jsPlumb.setContainer($('.canvas'));
            });

            jsPlumb.bind("beforeDrop", function (connection) {
                _resolveManualConnection(connection);
                $rootScope.isDraggingLoop = false;
                return false;
            });

            jsPlumb.bind("connectionDrag", function (connection) {
                if(connection.sourceId.indexOf('looping-conn-') > -1) {
                    $rootScope.isDraggingLoop = true;
                }
            });

            jsPlumb.bind("connectionDragStop", function (connection) {
                $rootScope.isDraggingLoop = false;
            });
        };

        var setInitDragConnect = function (sourceEl) {
            jsPlumb.ready(function () {
                //Add drag event
                jsPlumb.draggable(sourceEl.id, {containment: 'parent'});

                var manualSource = document.getElementsByClassName("add-connection"),
                    commonManualConnect = {
                        connector: ['Straight'],
                        anchor: ['Left', 'Right'],
                        endpoint: "Blank",
                        connectorStyle: {
                            gradient: {stops: [[0, '#4F4FC9'], [1, '#4F4FC9']]},
                            lineWidth: 2,
                            strokeStyle: '#4F4FC9'
                        }
                    };

                //Manual Source
                jsPlumb.makeSource(manualSource, {}, commonManualConnect);

            });
        };

        var simpleConnect = function(source, target, color) {
                //Options
                var common = {
                    connector: ['Straight'],
                    anchor: ['Left', 'Right', 'Top', 'Bottom'],
                    endpoint: "Blank"
                };

                //Connect
                jsPlumb.connect({
                    source: source,
                    target: target,

                    paintStyle: {
                        lineWidth: 2,
                        strokeStyle: color
                    },
                    overlays: [
                        ["Arrow", {width: 11, length: 10, location: 1}]
                    ]

                }, common);
        };

        var connectElements = function (sourceEl, targetEl) {
            var targetType = targetEl.type,
                targetNode,
                arrowLocation;

            if (targetType === 'Action') {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = -80;
            }
            else if(targetType === 'Condition') {
                targetNode = targetEl.id + '-center-target';
                arrowLocation = -94;
            } else if(targetType === 'Looping') {
                    targetNode =  targetEl.id + '-center-target';
                    arrowLocation = -71;
            } else {
                targetNode =  targetEl.id + '-center-target';
                arrowLocation = 1;
            }

            //Options
            var common = {
                connector: ['Straight'],
                anchor: ['Left', 'Right', 'Top', 'Bottom'],
                endpoint: "Blank"
            };

            //Connect
            jsPlumb.connect({
                source: sourceEl.id+'-center',
                target: targetNode,

                paintStyle: {
                    gradient: {stops: [[0, sourceEl.color], [1, targetEl.color]]},
                    lineWidth: 2,
                    strokeStyle: targetEl.color
                },
                endpointStyles: [{gradient: {stops: [[0, sourceEl.color], [1, targetEl.color]]}}],
                overlays: [
                    ["Arrow", {width: 11, length: 10, location: arrowLocation}]
                ]

            }, common);

            //Getting the source Element
            var sourceElement = angular.element(document.querySelector('#'+ sourceEl.id));
            //Setting the plus-menu invisible
            angular.element(sourceElement[0].querySelector('.plus-menu')).addClass("invisible");
            //Remove visible class
            angular.element(sourceElement[0].querySelector('.plus-menu')).removeClass("visible");

            //Add Visible class to the connect Icon
            angular.element(sourceElement[0].querySelector('.add-connection')).addClass("invisible");
            //Set the connect icon invisible for the user when connection exist
            angular.element(sourceElement[0].querySelector('.add-connection')).removeClass("visible");

            $rootScope.$emit('arrowReconnected' + sourceEl.id, sourceEl.id);

            //Add drag event
            jsPlumb.draggable(sourceEl.id, {containment: 'parent'});
            jsPlumb.draggable(targetEl.id, {containment: 'parent'});

            _setManualConnections(sourceEl.color, targetEl.color);
        };

        let connectLoopingElements = (sourceEl, targetEl) => {
            if(!targetEl) {
                return;
            }

            var targetType = targetEl.type,
                targetNode,
                arrowLocation;

            if (targetType === 'Action') {
                targetNode = targetEl.id + '-center-looping';
                arrowLocation = -79;
            }
            else if(targetType === 'Condition') {
                targetNode =  targetEl.id + '-center-looping';
                arrowLocation = -93;
            } else {
                targetNode =  targetEl.id + '-center-looping';
                arrowLocation = -80;
            }

            //Options
            var common = {
                connector: ['Straight'],
                anchor: ['Left', 'Right', 'Top', 'Bottom'],
                endpoint: "Blank"
            };

            //Connect
            jsPlumb.connect({
                source: sourceEl.id+'-center',
                target: targetNode,

                paintStyle: {
                    gradient: {stops: [[0, sourceEl.color], [1, targetEl.color]]},
                    lineWidth: 2,
                    strokeStyle: targetEl.color
                },
                endpointStyles: [{gradient: {stops: [[0, sourceEl.color], [1, targetEl.color]]}}],
                overlays: [
                    ["Arrow", {width: 11, length: 10, location: arrowLocation}]
                ]

            }, common);

            $rootScope.$emit('showConnectionArrow_' + sourceEl.id, false, sourceEl.id);
            $rootScope.$emit('showDeleteArrow_' + sourceEl.id, true, sourceEl.id);

            //Add drag event
            jsPlumb.draggable(sourceEl.id, {containment: 'parent'});
            jsPlumb.draggable(targetEl.id, {containment: 'parent'});

            _setManualConnections(sourceEl.color, targetEl.color);
        };

        var makeDraggable = function(id) {
            //Add drag event
            jsPlumb.draggable(id, {containment: 'parent'});
        };


        var _setManualConnections = function (sourceColor, targetColor) {
            var manualSource = document.getElementsByClassName("add-connection"),
                manualTarget = document.getElementsByClassName("shape"),
                commonManualConnect = {
                    connector: ['Straight'],
                    anchor: ['Left', 'Right'],
                    endpoint: "Blank",
                    connectorStyle: {
                        gradient: {stops: [[0, sourceColor], [1, targetColor]]},
                        lineWidth: 2,
                        strokeStyle: targetColor
                    }
                };

            var filteredSource = Array.prototype.filter.call(manualSource, function (el) {
                return el.className.indexOf('jsplumb-droppable') == -1;
            });

            var filteredTarget = Array.prototype.filter.call(manualTarget, function (el) {
                return el.className.indexOf('jsplumb-droppable') == -1;
            });

            //Manual Source
            if(filteredSource.length) {
                jsPlumb.makeSource(filteredSource, {}, commonManualConnect);
            }

            //Manual Target
            if(filteredTarget.length) {
                jsPlumb.makeTarget(filteredTarget, {}, commonManualConnect);
            }

        };

        var _resolveManualConnection = function (connection) {
            var sourceId = $('#' + connection.sourceId).closest('div.shape').attr('id'),
                source, target;
            if (sourceId !== connection.targetId) {
                source = helpers.getConnectionById(sourceId);
                target = helpers.getConnectionById(connection.targetId);

                if (_isLooping(source, target)) {
                    //connect and update rootscope, and save journey
                    connectLoopingElements(source, target);
                    helpers.updateChildrenProp(source.id, target.id);
                    $rootScope.$emit('arrowReconnected' + source.id, source.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                } else if (_isConnectable(source, target)) {
                    //connect and update rootscope, and save journey
                    connectElements(source, target);
                    helpers.updateParentProp(source.id, target.id);
                    helpers.updateChildrenProp(source.id, target.id);
                    helpers.reOrderConnections();
                    $rootScope.$emit('arrowReconnected' + source.id, source.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                } else {
                    console.log('Element already connected');
                }
            }
            else {
                console.log('not elegible for connection');
                return false;
            }
        };

        let _isLooping = (source, target) => {
            if(target.type === 'RectangleConnection') {
                return false;
            }

            if(target.type === 'Entry') {
                return false;
            }

            if(target.type === 'Looping') {
                return false;
            }

            if(source.parent === target.id) {
                return false;
            }

            if (source.type === 'Looping') {
                return true;
            }

            return false;
        };

        var _isConnectable = function (source, target) {

            //means its not saved yet
            if (!source) {
                return false;
            }

            //means its not saved yet
            if (!target) {
                return false;
            }

            //Do not connect entry as target
            if (target.type === 'Entry') {
                return false;
            }

            if (source.type === 'Looping' && target.type === 'Looping') {
                return false;
            }

            //Checks for the parent property
            if (target.hasOwnProperty('parent') && target.parent) {
                return false;
            }
            //Checks if the source has a current connection
            if (helpers.checkIfIsConnected(source.id)) {
                return false;
            }

            return true;
        };

        //Delete Elements Function
        var deleteElements = function (elem) {
            //Select the parent Element.
            var parentElement = angular.element(document.querySelector('#'+ elem.parent));
            // to hide the delete arrow button
            $rootScope.$emit('hideArrowDelete' + elem.parent, elem.parent);
            if(parentElement[0]) {
                //Add Visible class to the menu Icon
                angular.element(parentElement[0].querySelector('.plus-menu')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(parentElement[0].querySelector('.plus-menu')).removeClass("invisible");

                //Add Visible class to the menu Icon
                angular.element(parentElement[0].querySelector('.add-connection')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(parentElement[0].querySelector('.add-connection')).removeClass("invisible");

            }
            jsPlumb.ready(function () {
                var shapeDelete, el, arrowDelete, arrowDeleteTarget, loopDeleteTarget;

                shapeDelete = angular.element(document.querySelector('#' + elem.id));
                arrowDelete = angular.element(document.querySelector('#' + elem.id+'-center'));
                arrowDeleteTarget = angular.element(document.querySelector('#' + elem.id+'-center-target'));
                loopDeleteTarget = angular.element(document.querySelector('#' + elem.id+'-center-looping'));

                jsPlumb.detachAllConnections(shapeDelete);
                jsPlumb.detachAllConnections(arrowDelete);
                jsPlumb.detachAllConnections(arrowDeleteTarget);
                jsPlumb.detachAllConnections(loopDeleteTarget);

                shapeDelete.remove();
                el = helpers.deleteConnection(elem);

                if (el && el.elem) {
                    helpers.removeSiblings(el.elem.id);
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                }
            });
        };

        var deleteArrows = function(elem) {
            //Select the parent Element.
            var currentElem = angular.element(document.querySelector('#'+ elem.id));
            if(currentElem[0]) {
                //Add Visible class to the menu Icon
                angular.element(currentElem[0].querySelector('.plus-menu')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(currentElem[0].querySelector('.plus-menu')).removeClass("invisible");

                //Add Visible class to the menu Icon
                angular.element(currentElem[0].querySelector('.add-connection')).addClass("visible");
                //Set the menu invisible for the user
                angular.element(currentElem[0].querySelector('.add-connection')).removeClass("invisible");

            }

            jsPlumb.ready(function () {
                var arrowDelete;

                arrowDelete = angular.element(document.querySelector('#' + elem.id+'-center'));
                jsPlumb.detachAllConnections(arrowDelete);

                if (elem.id) {
                   helpers.deleteParent(elem.id);
                   canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);
                }
            });
        };

        var lastElem;
        var getLastElemClicked = function () {
            return lastElem;
        };

        var setLastElemClicked = function (elemClicked) {
            lastElem = elemClicked;
            return lastElem;
        };

        return {
            //Starts jsPlumb
            initPlumb: initPlumb,
            //Connects two elements with jsPlumb
            connectElements: connectElements,
            // connect two looping elements
            connectLoopingElements: connectLoopingElements,
            //Sets the last element clicked
            setLastElemClicked: setLastElemClicked,
            //Get the id of the canvas element that was clicked
            getLastElemClicked: getLastElemClicked,
            //Delete elements(shapes)
            deleteElements: deleteElements,
            //Set Single element initial state
            setInitDragConnect: setInitDragConnect,
            //Makes an element draggable
            makeDraggable: makeDraggable,
            //Sets a manual connection
            setManualConnection: _setManualConnections,
            //Deletes only arrow connection
            deleteArrows: deleteArrows,
            // does a simple connection
            simpleConnect: simpleConnect
        }
    }

    function preBuildServices($q, $rootScope, canvasService, $location) {
        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            //Checks if path contains canvas word in the url
            var isCanvasPath = function () {
                return $location.path().indexOf('canvas') > -1;
            };

            if(!$rootScope.journeyDefaultTemplates && isCanvasPath()) {
                var templatePromises = [
                    canvasService.preloadDefaultJourneys(1),
                    canvasService.preloadDefaultJourneys(2),
                    canvasService.preloadDefaultJourneys(3),
                    canvasService.preloadDefaultJourneys(4),
                    canvasService.preloadDefaultJourneys(5),
                    canvasService.preloadDefaultJourneys(6),
                    canvasService.preloadDefaultJourneys(7),
                    canvasService.preloadDefaultJourneys(8),
                    canvasService.preloadDefaultJourneys(9)
                ];

                $q.all(templatePromises).then(function (results) {
                    $rootScope.journeyDefaultTemplates = results.map(function(res) {
                        return res.data;
                    });
                });
            }
        });
    }

    function getTestEnvUrls() {
        return [
            'jbdev.benchmarkemail.com',
            'apbeta.benchmarkemail.com',
            'aptest.benchmarkemail.com'
        ];
    }

    function calcAProApiUrl() {
        var serviceUrl = 'https://aproapi.benchmarkemail.com/';

        if(getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://aproapi.beta.benchmarkemail.com/';
        }

        return serviceUrl;
    }

    function calcAProHubUrl() {
        var serviceUrl = 'https://reports.benchmarkemail.com/private';

        if(getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://reports.beta.benchmarkemail.com/private';
        }

        return serviceUrl;
    }

    function calcIntegrationsApiUrl() {
        var serviceUrl = 'https://aproapi.benchmarkemail.com/integrations/api/v1/';

        if (getTestEnvUrls().indexOf(window.location.hostname) > -1) {
            serviceUrl = 'https://intgrapi.beta.benchmarkemail.com/api/v1/';
        }

        return serviceUrl;
    }

})();



// WEBPACK FOOTER //
// ./app/services/canvas.service.js